import React from 'react';
import SubscriptionSettingsTab from '../components/SubscriptionSettingsTab';

const SubscriptionsPage: React.FC = () => {
  return (
    <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white transition-colors">
          Subscriptions
        </h1>
        <p className="mt-2 text-gray-600 dark:text-gray-400 transition-colors">
          View and manage your subscription plans and billing information
        </p>
      </div>

      {/* Content */}
      <SubscriptionSettingsTab />
    </div>
  );
};

export default SubscriptionsPage;
